(function () {
    "use strict";

    angular.module("eSign")
      .controller("UploadDocumentsController", ['$scope', '$http', '$window', 'fileUpload', 'signTaskService', 'appConfig',
      function ($scope, $http, $window, fileUpload, signTaskService, appConfig) {

          $scope.uploadLater = false;
          $scope.files = [];
          $scope.offerInsurance = false;
          $scope.waiting = false;
          $scope.uploadError = false;

          $scope.init = function (value) {
              //This function is sort of private constructor for controller
              $scope.offerInsurance = value;
          };

          var getNextStep = function () {
              console.log('OfferInsurance:' + $scope.offerInsurance);
              var url = appConfig.signCompletedUrl;
              if ($scope.offerInsurance) url = appConfig.insuranceUrl;
              console.log('nextUrl:' + url);
              $scope.waiting = false;
              return url;
          };
          
          // On continue button clicked: upload files if the user didnt check the defer upload checkbox, set upload document step complete, then redirect to signing completed page.
          $scope.submitForm = function (skip) {
              $scope.waiting = true;
              $scope.uploadError = false;
              if ($scope.files.length !== $scope.requiredUploads.length) {
                  console.log("Files missing");
                  console.log("Files");
                  console.log($scope.files);
                  console.log("Required uploads:");
                  console.log($scope.requiredUploads);
              }

              if (!skip) {
                  var uploadUrl = signTaskService.getUploadDocumentURL();
                  var deferred = false;
                  for (var i = 0; i < $scope.files.length; i++) {
                      if ($scope.files[i] === null || typeof $scope.files[i] == 'undefined') deferred = true;
                  }
                  fileUpload.uploadFileToUrl($scope.files, $scope.requiredUploads, uploadUrl).then(function (response) {
                      console.log('uploadDocument ' + response.data);
                      if (response.data === null) {
                          console.log("Empty response");
                          $scope.waiting = false;
                          $scope.uploadError = true;
                      } else {
                          console.log("OK response");
                          // Set upload document step complete, deferUpload to false.
                          signTaskService.setUploadDocumentStepComplete(deferred).then(function (response) {
                              console.log("setUploadDocumentStepComplete:" + deferred);
                              $window.location.href = getNextStep();
                          });
                      }
                  });

              } else {
                  signTaskService.setUploadDocumentStepComplete(true).then(function(response) {
                      console.log("setUploadDocumentStepComplete:");
                      $window.location.href = getNextStep();
                  });
              }
          };

          // A check for ng-disabled on the continue button.
          $scope.disableContinueButton = function () {
              if ($scope.uploadLater === true) {
                  return false;
              }

              for (var i = 0; i < $scope.files.length; i++) {
                  var file = $scope.files[i];
                  if (typeof file == 'object' && file !== null) {
                      return false;
                  }
              }
              return true;
          };

          $scope.goBack = function() {
            $window.location.href = appConfig.chooseDocumentUrl;
          };

          // Get a list of required uploads for the current signtask
          var getRequiredUploadsForCurrentSignTask = function () {

              signTaskService.getRequiredUploadsForCurrentSignTask().then(function (response) {

                  $scope.requiredUploads = response.data;
                  /*
                  // dummy data
                  $scope.requiredUploads = [
                    {
                        uploadReference: "TemporaryUploadReference",
                        Name: "L�nnslipp",
                        IsUploaded: false
                    }
                  ];
                  */

                  
                  // Create the list to store file arrays.
                  $scope.files = Array.apply(null, Array($scope.requiredUploads.length)).map(function () { });
              });

          };

          getRequiredUploadsForCurrentSignTask();
      }]);
}());
